export default __webpack_public_path__ + "static/open-a63d8420247c7626d1de199710c03eff.png";